var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{staticClass:"copyright"},[_vm._v("©")]),_vm._v(" Suzanna Wentzel, 2025")])
}]

export { render, staticRenderFns }